import React , {Component } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';

class Icons_ion extends Component{
 
render(){
    return(
           <AUX>
		       <div className="page-content-wrapper">
            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-body">

                                <h4 className="mt-0 header-title">Examples</h4>
                                <p className="text-muted m-b-30 font-14">Use <code>&lt;i className="ion-ionic"&gt;&lt;/i&gt;</code>.
                                </p>

                                <div className="row icon-demo-content">

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ionic"></i>ion-ionic
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-up-a"></i>ion-arrow-up-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-right-a"></i>ion-arrow-right-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-down-a"></i>ion-arrow-down-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-left-a"></i>ion-arrow-left-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-up-b"></i>ion-arrow-up-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-right-b"></i>ion-arrow-right-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-down-b"></i>ion-arrow-down-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-left-b"></i>ion-arrow-left-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-up-c"></i>ion-arrow-up-c
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-right-c"></i>ion-arrow-right-c
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-down-c"></i>ion-arrow-down-c
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-left-c"></i>ion-arrow-left-c
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-return-right"></i>ion-arrow-return-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-return-left"></i>ion-arrow-return-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-swap"></i>ion-arrow-swap
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-shrink"></i>ion-arrow-shrink
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-expand"></i>ion-arrow-expand
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-move"></i>ion-arrow-move
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-resize"></i>ion-arrow-resize
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chevron-up"></i>ion-chevron-up
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chevron-right"></i>ion-chevron-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chevron-down"></i>ion-chevron-down
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chevron-left"></i>ion-chevron-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-navicon-round"></i>ion-navicon-round
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-navicon"></i>ion-navicon
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-drag"></i>ion-drag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-log-in"></i>ion-log-in
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-log-out"></i>ion-log-out
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-checkmark-round"></i>ion-checkmark-round
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-checkmark"></i>ion-checkmark
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-checkmark-circled"></i>ion-checkmark-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-close-round"></i>ion-close-round
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-close"></i>ion-close
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-close-circled"></i>ion-close-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-plus-round"></i>ion-plus-round
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-plus"></i>ion-plus
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-plus-circled"></i>ion-plus-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-minus-round"></i>ion-minus-round
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-minus"></i>ion-minus
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-minus-circled"></i>ion-minus-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-information"></i>ion-information
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-information-circled"></i>ion-information-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-help"></i>ion-help
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-help-circled"></i>ion-help-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-help-buoy"></i>ion-help-buoy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-asterisk"></i>ion-asterisk
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-alert"></i>ion-alert
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-alert-circled"></i>ion-alert-circled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-refresh"></i>ion-refresh
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-loop"></i>ion-loop
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-shuffle"></i>ion-shuffle
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-home"></i>ion-home
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-search"></i>ion-search
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-flag"></i>ion-flag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-star"></i>ion-star
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-heart"></i>ion-heart
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-heart-broken"></i>ion-heart-broken
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-gear-a"></i>ion-gear-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-gear-b"></i>ion-gear-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-toggle-filled"></i>ion-toggle-filled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-toggle"></i>ion-toggle
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-settings"></i>ion-settings
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-wrench"></i>ion-wrench
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-folder"></i>ion-folder
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-hammer"></i>ion-hammer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-edit"></i>ion-edit
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-trash-a"></i>ion-trash-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-trash-b"></i>ion-trash-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-document"></i>ion-document
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-document-text"></i>ion-document-text
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-clipboard"></i>ion-clipboard
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-scissors"></i>ion-scissors
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-funnel"></i>ion-funnel
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-bookmark"></i>ion-bookmark
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-email"></i>ion-email
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-folder"></i>ion-folder
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-filing"></i>ion-filing
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-archive"></i>ion-archive
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-reply"></i>ion-reply
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-reply-all"></i>ion-reply-all
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-forward"></i>ion-forward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-share"></i>ion-share
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-paper-airplane"></i>ion-paper-airplane
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-link"></i>ion-link
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-paperclip"></i>ion paperclip
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-compose"></i>ion-compose
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-briefcase"></i>ion-briefcase
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-medkit"></i>ion-medkit
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-at"></i>ion-at
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pound"></i>ion-pound
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-quote"></i>ion-quote
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-cloud"></i>ion-cloud
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-upload"></i>ion-upload
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-more"></i>ion-more
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-grid"></i>ion-grid
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-calendar"></i>ion-calendar
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-clock"></i>ion-clock
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-compass"></i>ion-compass
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pinpoint"></i>ion-pinpoint
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pin"></i>ion-pin
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-navigate"></i>ion-navigate
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-location"></i>ion-location
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-map"></i>ion-map
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-model-s"></i>ion-model-s
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-locked"></i>ion-locked
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-unlocked"></i>ion-unlocked
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-key"></i>ion-key
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-graph-up-right"></i>ion-arrow-graph-up-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-graph-down-right"></i>ion-arrow-graph-down-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-arrow-graph-down-left"></i>ion-arrow-graph-down-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-stats-bars"></i>ion-stats-bars
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-connection-bars"></i>ion-connection-bars
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pie-graph"></i>ion-pie-graph
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chatbubble"></i>ion-chatbubble
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chatbubble-working"></i>ion-chatbubble-working
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chatbubbles"></i>ion-chatbubbles
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chatbox"></i>ion-chatbox
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chatbox-working"></i>ion-chatbox-working
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-chatboxes"></i>ion-chatboxes
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-person"></i>ion-person
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-person-add"></i>ion-person-add
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-person-stalker"></i>ion-person-stalker
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-woman"></i>ion-woman
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-man"></i>ion-man
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-female"></i>ion-female
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-male"></i>ion-male
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-fork"></i>ion-fork
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-knife"></i>ion-knife
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-spoon"></i>ion-spoon
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-beer"></i>ion-beer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-wineglass"></i>ion-wineglass
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-coffee"></i>ion-coffee
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-icecream"></i>ion-icecream
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pizza"></i>ion-pizza
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-power"></i>ion-power
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-mouse"></i>ion-mouse
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-battery-full"></i>ion-battery-full
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-battery-half"></i>ion-battery-half
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-battery-low"></i>ion-battery-low
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-battery-empty"></i>ion-battery-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-battery-charging"></i>ion-battery-charging
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-wifi"></i>ion-wifi
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-bluetooth"></i>ion-bluetooth
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-calculator"></i>ion-calculator
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-camera"></i>ion-camera
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-eye"></i>ion-eye
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-eye-disabled"></i>ion-eye-disabled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-flash"></i>ion-flash
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-flash-off"></i>ion-flash-off
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-qr-scanner"></i>ion-qr-scanner
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-image"></i>ion-image
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-images"></i>ion-images
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-contrast"></i>ion-contrast
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-wand"></i>ion-wall
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-aperture"></i>ion-aperture
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-monitor"></i>ion-monitor
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-laptop"></i>ion-laptop
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ipad"></i>ion-ipad
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-iphone"></i>ion-iphone
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ipod"></i>ion-ipod
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-printer"></i>ion-printer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-usb"></i>ion-usb
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-outlet"></i>ion-outlet
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-bug"></i>ion-bug
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-code"></i>ion-code
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-code-working"></i>ion-code-working
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-code-download"></i>ion-code-download
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-fork-repo"></i>ion-fork-repo
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-network"></i>ion-network
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pull-request"></i>ion-pull-request
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-merge"></i>ion-go
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-game-controller-a"></i>ion-game-controller-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-game-controller-b"></i>ion-game-controller-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-xbox"></i>ion-xbox
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-playstation"></i>ion-playstation
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-steam"></i>ion-steam
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-closed-captioning"></i>ion-closed-captioning
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-videocamera"></i>ion-camera
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-film-marker"></i>ion-film-marker
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-disc"></i>ion-disc
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-headphone"></i>ion-headphone
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-music-note"></i>ion-music-note
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-radio-waves"></i>ion-radio-waves
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-speakerphone"></i>ion-speakerphone
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-mic-a"></i>ion-mic-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-mic-b"></i>ion-mic-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-mic-c"></i>ion-mic-c
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-volume-high"></i>ion-volume-high
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-volume-medium"></i>ion-volume-medium
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-volume-low"></i>ion-volume-low
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-volume-mute"></i>ion-volume-mute
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-levels"></i>ion-levels
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-play"></i>ion-play
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pause"></i>ion-pause
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-stop"></i>ion-stop
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-record"></i>ion-record
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-skip-forward"></i>ion-skip-forward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-skip-backward"></i>ion-skip-backward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-eject"></i>ion-eject
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-bag"></i>ion-bag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-card"></i>ion-card
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-cash"></i>ion-cash
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pricetag"></i>ion-pricetag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-pricetags"></i>ion-pricetags
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-thumbsup"></i>ion-thumbsup
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-thumbsdown"></i>ion-thumbsdown
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-happy"></i>ion-happy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-sad"></i>ion-sad
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-trophy"></i>ion-trophy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-podium"></i>ion-podium
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ribbon-a"></i>ion-ribbon-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ribbon-b"></i>ion-ribbon-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-university"></i>ion-university
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-magnet"></i>ion-magnet
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-beaker"></i>ion-beaker
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-flask"></i>ion-flask
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-egg"></i>ion-egg
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-earth"></i>ion-earth
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-planet"></i>ion-planet
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-lightbulb"></i>ion-lightbulb
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-cube"></i>ion-cube
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-leaf"></i>ion-leaf
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-waterdrop"></i>ion-waterdrop
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-flame"></i>ion-flame
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-fireball"></i>ion-fireball
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-bonfire"></i>ion-bonfire
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-umbrella"></i>ion-umbrella
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-nuclear"></i>ion-nuclear
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-no-smoking"></i>ion-no-smoking
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-thermometer"></i>ion-thermometer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-speedometer"></i>ion-speedometer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-plane"></i>ion-plane
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-jet"></i>ion-jet
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-load-a"></i>ion-load-a
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-load-b"></i>ion-load-b
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-load-c"></i>ion-load-c
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-load-d"></i>ion-load-d
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-ionic-outline"></i>ion-ios7-ionic-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-back"></i>ion-ios7-arrow-back
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-forward"></i>ion-ios7-arrow-forward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-up"></i>ion-ios7-arrow-up
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-right"></i>ion-ios7-arrow-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-down"></i>ion-ios7-arrow-down
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-left"></i>ion-ios7-arrow-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-thin-up"></i>ion-ios7-arrow-thin-up
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-thin-right"></i>ion-ios7-arrow-thin-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-thin-down"></i>ion-ios7-arrow-thin-down
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-arrow-thin-left"></i>ion-ios7-arrow-thin-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-circle-filled"></i>ion-ios7-circle-filled
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-circle-outline"></i>ion-ios7-circle-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-checkmark-empty"></i>ion-ios7-checkmark-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-checkmark-outline"></i>ion-ios7-checkmark-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-checkmark"></i>ion-ios7-checkmark
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-plus-empty"></i>ion-ios7-plus-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-plus-outline"></i>ion-ios7-plus-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-plus"></i>ion-ios7 more
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-close-empty"></i>ion-ios7-close-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-close-outline"></i>ion-ios7-close-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-close"></i>ion-ios7-close
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-minus-empty"></i>ion-ios7-minus-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-minus-outline"></i>ion-ios7-minus-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-minus"></i>ion-ios7-minus
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-information-empty"></i>ion-ios7-information-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-information-outline"></i>ion-ios7-information-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-information"></i>ion-ios7-information
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-help-empty"></i>ion-ios7-help-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-help-outline"></i>ion-ios7-help-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-help"></i>ion-ios7-help
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-search"></i>ion-ios7-search
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-search-strong"></i>ion-ios7-search-strong
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-star"></i>ion-ios7-star
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-star-half"></i>ion-ios7-star-half
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-star-outline"></i>ion-ios7-star-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-heart"></i>ion-ios7-heart
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-heart-outline"></i>ion-ios7-heart-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-more"></i>ion-ios7-more
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-more-outline"></i>ion-ios7-more-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-home"></i>ion-ios7-home
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-home-outline"></i>ion-ios7-home-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloud"></i>ion-ios7-cloud
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloud-outline"></i>ion-ios7-cloud-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloud-upload"></i>ion-ios7-cloud-upload
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloud-upload-outline"></i>ion-ios7-cloud-upload-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloud-download"></i>ion-ios7-cloud-download
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloud-download-outline"></i>ion-ios7-cloud-download-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-upload"></i>ion-ios7-upload
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-upload-outline"></i>ion-ios7-upload-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-download"></i>ion-ios7-download
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-download-outline"></i>ion-ios7-download-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-refresh"></i>ion-ios7-refresh
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-refresh-outline"></i>ion-ios7-refresh-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-refresh-empty"></i>ion-ios7-refresh-empty
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-reload"></i>ion-ios7-reload
                                    </div>


                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-loop-strong"></i>ion-ios7-loop-strong
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-loop"></i>ion-ios7-loop
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-bookmarks"></i>ion-ios7-bookmarks
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-bookmarks-outline"></i>ion-ios7-bookmarks-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-flag"></i>ion-ios7-flag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-flag-outline"></i>ion-ios7-flag-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-glasses"></i>ion-ios7-glasses
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-glasses-outline"></i>ion-ios7-glasses-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-browsers"></i>ion-ios7-browsers
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-browsers-outline"></i>ion-ios7-browsers-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-at"></i>ion-ios7-at
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-at-outline"></i>ion-ios7-at-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cart"></i>ion-ios7-cart
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cart-outline"></i>ion-ios7-cart-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pricetag"></i>ion-ios7-pricetag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pricetag-outline"></i>ion-ios7-pricetag-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pricetags"></i>ion-ios7-pricetags
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pricetags-outline"></i>ion-ios7-pricetags-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-chatboxes"></i>ion-ios7-chatboxes
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-chatboxes-outline"></i>ion-ios7-chatboxes-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-chatbubble"></i>ion-ios7-chatbubble
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-chatbubble-outline"></i>ion-ios7-chatbubble-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cog"></i>ion-ios7-cog
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cog-outline"></i>ion-ios7-cog-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-gear"></i>ion-ios7-gear
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-gear-outline"></i>ion-ios7-gear-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-settings"></i>ion-ios7-settings
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-settings-strong"></i>ion-ios7-settings-strong
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-toggle"></i>ion-ios7-toggle
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-toggle-outline"></i>ion-ios7-toggle-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-analytics"></i>ion-ios7-analytics
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-analytics-outline"></i>ion-ios7-analytics-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pie"></i>ion-ios7-pie
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pie-outline"></i>ion-ios7-pie-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pulse"></i>ion-ios7-pulse
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pulse-strong"></i>ion-ios7-pulse-strong
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-filing"></i>ion-ios7-filing
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-filing-outline"></i>ion-ios7-filing-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-box"></i>ion-ios7-box
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-box-outline"></i>ion-ios7-box-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-compose"></i>ion-ios7-compose
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-compose-outline"></i>ion-ios7-compose-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-trash"></i>ion-ios7-trash
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-trash-outline"></i>ion-ios7-trash-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-copy"></i>ion-ios7-copy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-copy-outline"></i>ion-ios7-copy-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-email"></i>ion-ios7-email
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-email-outline"></i>ion-ios7-email-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-undo"></i>ion-ios7-undo
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-undo-outline"></i>ion-ios7-undo-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-redo"></i>ion ios7-ready
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-redo-outline"></i>ion-ios7-redo-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-redo-outline"></i>ion-ios7-redo-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-paperplane"></i>ion-ios7-paperplane
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-paperplane-outline"></i>ion-ios7-paperplane-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-folder"></i>ion-ios7-folder
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-folder-outline"></i>ion-ios7-folder-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-paper"></i>ion-ios7-paper
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-paper-outline"></i>ion-ios7-paper-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-world"></i>ion-ios7-world
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-world-outline"></i>ion-ios7-world-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-alarm"></i>ion-ios7-alarm
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-alarm-outline"></i>ion-ios7-alarm-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-speedometer"></i>ion-ios7-speedometer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-speedometer-outline"></i>ion-ios7-speedometer-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-stopwatch"></i>ion-ios7-stopwatch
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-stopwatch-outline"></i>ion-ios7-stopwatch-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-timer"></i>ion-ios7-timer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-timer-outline"></i>ion-ios7-timer-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-clock"></i>ion-ios7-clock
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-clock-outline"></i>ion-ios7-clock-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-time"></i>ion-ios7-time
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-time-outline"></i>ion-ios7-time-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-calendar"></i>ion-ios7-calendar
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-calendar-outline"></i>ion-ios7-calendar-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-photos"></i>ion-ios7-photos
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-photos-outline"></i>ion-ios7-photos-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-albums"></i>ion-ios7-albums
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-albums-outline"></i>ion-ios7-albums-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-camera"></i>ion-ios7-camera
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-camera-outline"></i>ion-ios7-camera-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-reverse-camera"></i>ion-ios7-reverse-camera
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-reverse-camera-outline"></i>ion-ios7-reverse-camera-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-eye"></i>ion-ios7-eye
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-eye-outline"></i>ion-ios7-eye-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-bolt"></i>ion-ios7-bolt
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-bolt-outline"></i>ion-ios7-bolt-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-barcode"></i>ion-ios7-barcode
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-barcode-outline"></i>ion-ios7-barcode-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-briefcase"></i>ion-ios7-briefcase
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-briefcase-outline"></i>ion-ios7-briefcase-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-medkit"></i>ion-ios7-medkit
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-medkit-outline"></i>ion-ios7-medkit-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-infinite"></i>ion-ios7-infinite
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-infinite-outline"></i>ion-ios7-infinite-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-calculator"></i>ion-ios7-calculator
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-calculator-outline"></i>ion-ios7-calculator-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-keypad"></i>ion-ios7-keypad
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-keypad-outline"></i>ion-ios7-keypad-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-telephone"></i>ion-ios7-telephone
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-telephone-outline"></i>ion-ios7-telephone-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-drag"></i>ion-ios7-drag
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-location"></i>ion-ios7-location
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-location-outline"></i>ion-ios7-location-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-navigate"></i>ion-ios7-navigate
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-navigate-outline"></i>ion-ios7-navigate-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-locked"></i>ion-ios7-locked
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-locked-outline"></i>ion-ios7-locked-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-unlocked"></i>ion-ios7-unlocked
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-unlocked-outline"></i>ion-ios7-unlocked-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-monitor"></i>ion-ios7-monitor
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-monitor-outline"></i>ion-ios7-monitor-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-printer"></i>ion-ios7-printer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-printer-outline"></i>ion-ios7-printer-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-person"></i>ion-ios7-person
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-person-outline"></i>ion-ios7-person-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-personadd"></i>ion-ios7-personadd
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-personadd-outline"></i>ion-ios7-personadd-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-people"></i>ion-ios7-people
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-people-outline"></i>ion-ios7-people-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-tennisball"></i>ion ios7-tennis ball
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-tennisball-outline"></i>ion ios7 tennis ball outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-baseball"></i>ion-ios7-baseball
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-baseball-outline"></i>ion-ios7-baseball-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-basketball"></i>ion-ios7-basketball
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-basketball-outline"></i>ion-ios7-basketball-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-football"></i>ion-ios7-football
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-football-outline"></i>ion-ios7-football-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-americanfootball"></i>ion-ios7-americanfootball
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-americanfootball-outline"></i>ion-ios7-americanfootball-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-paw"></i>ion-ios7-paw
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-paw-outline"></i>ion-ios7-paw-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-sunny"></i>ion-ios7-sunny
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-sunny-outline"></i>ion-ios7-sunny-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-partlysunny"></i>ion-ios7-partlysunny
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-partlysunny-outline"></i>ion-ios7-partlysunny-Outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloudy"></i>ion-ios7-cloudy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloudy-outline"></i>ion-ios7-cloudy-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-rainy"></i>ion-ios7-rainy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-rainy-outline"></i>ion-ios7-rainy-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-thunderstorm"></i>ion-ios7-thunderstorm
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-thunderstorm-outline"></i>ion-ios7-thunderstorm-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-snowy"></i>ion-ios7-snowy
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-moon"></i>ion-ios7-moon
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-moon-outline"></i>ion-ios7-moon-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloudy-night"></i>ion-ios7-cloudy-night
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-cloudy-night-outline"></i>ion-ios7-cloudy-night-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-musical-notes"></i>ion-ios7-musical-notes
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-musical-note"></i>ion-ios7-musical-note
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-bell"></i>ion-ios7-bell
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-bell-outline"></i>ion-ios7-bell-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-mic"></i>ion-ios7-small
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-mic-outline"></i>ion-ios7-mic-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-mic-off"></i>ion-ios7-mic-off
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-volume-high"></i>ion-ios7-volume-high
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-volume-low"></i>ion-ios7-volume-low
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-play"></i>ion-ios7-play
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-play-outline"></i>ion-ios7-play-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pause"></i>ion-ios7-pause
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-pause-outline"></i>ion-ios7-pause-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-recording"></i>ion-ios7-recording
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-recording-outline"></i>ion-ios7-recording-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-fastforward"></i>ion-iOS7-FastForward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-fastforward-outline"></i>ion-iOS7-FastForward-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-rewind"></i>ion-ios7-rewind
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-rewind-outline"></i>ion-ios7-rewind-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-skipbackward"></i>ion-ios7-skipbackward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-skipbackward-outline"></i>ion-ios7-skipbackward-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-skipforward"></i>ion-ios7-skipforward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-skipforward-outline"></i>ion-ios7-skipforward-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-videocam"></i>ion-iOS7-videocam
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-videocam-outline"></i>ion-ios7-videocam-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-film"></i>ion-ios7-film
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-film-outline"></i>ion-ios7-film-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-lightbulb"></i>ion-ios7-lightbulb
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-lightbulb-outline"></i>ion-ios7-lightbulb-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-wineglass"></i>ion-ios7-wineglass
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-ios7-wineglass-outline"></i>ion-ios7-wineglass-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-system-back"></i>ion-android-system-back
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-system-home"></i>ion-android-system-home
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-system-windows"></i>ion-android-system-windows
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-wifi"></i>ion-android-wifi
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-battery"></i>ion-android-battery
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-storage"></i>ion-android-storage
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-keypad"></i>ion-android-keypad
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-call"></i>ion-android-call
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-arrow-back"></i>ion-android-arrow-back
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-arrow-forward"></i>ion-android-arrow-forward
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-arrow-up-right"></i>ion-android-arrow-up-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-arrow-down-right"></i>ion-android-arrow-down-right
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-arrow-down-left"></i>ion-android-arrow-down-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-arrow-up-left"></i>ion-android-arrow-up-left
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-sort"></i>ion-android-sort
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-drawer"></i>ion-android-drawer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-stair-drawer"></i>ion-android-stair-drawer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-more"></i>ion-android-more
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-dropdown"></i>ion-android-dropdown
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-settings"></i>ion-android-settings
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-mixer"></i>ion-android-mixer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-display"></i>ion-android-display
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-star"></i>ion-android-star
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-search"></i>ion-android-search
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-microphone"></i>ion-android-microphone
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-checkmark"></i>ion-android-checkmark
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-information"></i>ion-android-information
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-add"></i>ion-android-add
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-remove"></i>ion-android-remove
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-close"></i>ion-android-close
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-trash"></i>ion-android-trash
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-volume"></i>ion-android-volume
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-printer"></i>ion-android-printer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-download"></i>ion-android-download
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-hand"></i>ion-android-hand
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-developer"></i>ion-android-developer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-calendar"></i>ion-android-calendar
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-clock"></i>ion-android-clock
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-alarm"></i>ion-android-alarm
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-stopwatch"></i>ion-android-stopwatch
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-data"></i>ion-android-data
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-timer"></i>ion-android-timer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-camera"></i>ion-android-camera
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-image"></i>ion-android-image
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-location"></i>ion-android-location
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-locate"></i>ion-android-locate
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-earth"></i>ion-android-earth
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-book"></i>ion-android-book
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-note"></i>ion-android-note
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-promotion"></i>ion-android-promotion
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-playstore"></i>ion-android-playstore
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-share"></i>ion-android-share
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-send"></i>ion-android-send
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-mail"></i>ion-android-mail
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-inbox"></i>ion-android-inbox
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-archive"></i>ion-android-archive
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-folder"></i>ion-android-folder
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-forums"></i>ion-android-forums
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-chat"></i>ion-android-chat
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-user-menu"></i>ion-android-user-menu
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-contact"></i>ion-android-contact
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-contacts"></i>ion-android-contacts
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-friends"></i>ion-android-friends
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-add-contact"></i>ion-android-add-contact
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-social-user"></i>ion-android-social-user
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-social"></i>ion-android-social
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-reminder"></i>ion-android-reminder
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-android-lightbulb"></i>ion-android-lightbulb
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-twitter"></i>ion-social-twitter
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-twitter-outline"></i>ion-social-twitter-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-facebook"></i>ion-social-facebook
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-facebook-outline"></i>ion-social-facebook-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-googleplus"></i>ion-social-googleplus
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-googleplus-outline"></i>ion-social-googleplus-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-google"></i>ion-social-google
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-google-outline"></i>ion-social-google-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-dribbble"></i>ion-social-dribbble
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-dribbble-outline"></i>ion-social-dribbble-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-github"></i>ion-social-github
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-github-outline"></i>ion-social-github-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-instagram"></i>ion-social-instagram
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-instagram-outline"></i>ion-social-instagram-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-foursquare"></i>ion-social-foursquare
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-foursquare-outline"></i>ion-social-foursquare-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-pinterest"></i>ion-social-pinterest
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-pinterest-outline"></i>ion-social-pinterest-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-rss"></i>ion-social-rss
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-rss-outline"></i>ion-social-rss-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-tumblr"></i>ion-social-tumblr
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-tumblr-outline"></i>ion-social-tumblr-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-wordpress"></i>ion-social-wordpress
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-wordpress-outline"></i>ion-social-wordpress-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-reddit"></i>ion-social-reddit
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-reddit-outline"></i>ion-social-reddit-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-hackernews"></i>ion-social-hackernews
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-hackernews-outline"></i>ion-social-hackernews-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-designernews"></i>ion-social-designernews
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-designernews-outline"></i>ion-social-designernews-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-yahoo"></i>ion-social-yahoo
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-yahoo-outline"></i>ion-social-yahoo-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-buffer"></i>ion-social-buffer
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-buffer-outline"></i>ion-social-buffer-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-skype"></i>ion-social-skype
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-skype-outline"></i>ion-social-skype-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-linkedin"></i>ion-social-linkedin
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-linkedin-outline"></i>ion-social-linkedin-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-usd"></i>ion-social-usd
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-usd-outline"></i>ion-social-usd-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-bitcoin"></i>ion-social-bitcoin
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-bitcoin-outline"></i>ion-social-bitcoin-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-vimeo"></i>ion-social-vimeo
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-vimeo-outline"></i>ion-social-vimeo-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-youtube"></i>ion-social-youtube
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-youtube-outline"></i>ion-social-youtube-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-dropbox"></i>ion-social-dropbox
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-dropbox-outline"></i>ion-social-dropbox-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-apple"></i>ion-social-apple
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-apple-outline"></i>ion-social-apple-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-android"></i>ion-social-android
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-android"></i>ion-social-android-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-windows"></i>ion-social-windows
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-windows-outline"></i>ion-social-windows-outline
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-tux"></i>ion-social-tux
                                    </div>

                                    <div className="col-xl-3 col-md-4 col-sm-6"><i className="ion-social-freebsd-devil"></i>ion-social-freebsd-devil
                                    </div>

                                </div> 
                            </div>
                        </div>
                    </div> 
                </div>
            </div> 
        </div>
            
           </AUX>
        );
    }
}

export default Icons_ion;   